export default "__VITE_ASSET__CIY5hEpt__"